import { UrlSegment, UrlMatchResult } from '@angular/router';

export function detailMatcher(url: UrlSegment[]): UrlMatchResult {
  if (url.length === 0) {
    return null;
  }
  const regex = /^(hotels|hoteles|hoteis)\/(detail|detalle|detalhe)\//;
  if (regex.test(url.join('/'))) {
    return { consumed: url, posParams: { query: url[2] } };
  }
  return null;
}

export function detailTicketsMatcher(url: UrlSegment[]): UrlMatchResult {
  if (url.length === 0) {
    return null;
  }

  const regex = /^(hotels|hoteles|hoteis)\/(add-ons)\//;
  if (regex.test(url.join('/'))) {
    return { consumed: url, posParams: { query: url[2] } };
  }
  return null;
}
